<template lang="html">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    id="mannequin-icon"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    xml:space="preserve"
    :width="width"
    :height="height"
    :fill="fillColor"
    stroke="white"
    stroke-width="10"
  >
    <linearGradient id="a">
      <stop offset="0" :stop-color="stopColor1" />
      <stop offset="1" :stop-color="stopColor2" />
    </linearGradient>
    <linearGradient
      id="b"
      gradientUnits="userSpaceOnUse"
      x1="-50"
      x2="210"
      xlink:href="#a"
      y1="192"
      y2="192"
    />
    <linearGradient
      id="c"
      gradientUnits="userSpaceOnUse"
      x1="-50"
      x2="210"
      xlink:href="#a"
      y1="224"
      y2="224"
    />
    <linearGradient
      id="d"
      gradientUnits="userSpaceOnUse"
      x1="-50"
      x2="210"
      xlink:href="#a"
      y1="120"
      y2="120"
    />
    <linearGradient
      id="e"
      gradientUnits="userSpaceOnUse"
      x1="-50"
      x2="210"
      xlink:href="#a"
      y1="238.392"
      y2="238.392"
    />
    <path
      d="m170.019531 451.992188h-50.003906v-32.273438c0-5.523438-4.480469-10.003906-10.003906-10.003906-5.519531 0-10 4.480468-10 10.003906v32.273438h-50.003907c-27.574218 0-50.007812 22.433593-50.007812 50.007812 0 5.523438 4.480469 10 10 10h200.027344c5.519531 0 10-4.476562 10-10 0-27.574219-22.433594-50.007812-50.007813-50.007812zm-148.304687 40.003906c4.128906-11.640625 15.253906-20 28.292968-20h120.011719c13.039063 0 24.164063 8.359375 28.289063 20zm0 0"
      fill="url(#b)"
    />
    <path
      d="m110.011719 394.71875c2.632812 0 5.210937-1.070312 7.070312-2.929688 1.863281-1.863281 2.933594-4.441406 2.933594-7.074218 0-2.628906-1.070313-5.207032-2.933594-7.070313-1.859375-1.867187-4.4375-2.929687-7.070312-2.929687-2.640625 0-5.210938 1.070312-7.070313 2.929687-1.859375 1.863281-2.929687 4.441407-2.929687 7.070313 0 2.632812 1.070312 5.210937 2.929687 7.074218 1.863282 1.859376 4.441406 2.929688 7.070313 2.929688zm0 0"
      fill="url(#c)"
    />
    <path
      d="m214.371094 66.382812-53.792969-25.476562c-3.691406-1.746094-6.078125-5.515625-6.078125-9.601562v-21.304688c0-5.523438-4.480469-10-10-10h-68.84375c-5.523438 0-10 4.476562-10 10v21.304688c0 4.085937-2.386719 7.855468-6.078125 9.601562l-53.792969 25.476562c-3.496094 1.65625-5.722656 5.175782-5.722656 9.039063v50.144531c0 1.855469.515625 3.675782 1.492188 5.257813l23.214843 37.582031c5.292969 8.570312 8.089844 18.421875 8.089844 28.492188 0 7.851562-1.75 15.765624-5.066406 22.882812-12.011719 25.800781-18.359375 54.480469-18.359375 82.945312v46.164063c0 5.523437 4.480468 10 10 10h90.578125.128906 90.578125c5.523438 0 10-4.476563 10-10v-46.164063c0-28.464843-6.347656-57.144531-18.359375-82.945312-3.3125-7.117188-5.066406-15.03125-5.066406-22.882812 0-10.070313 2.800781-19.921876 8.089843-28.492188l23.214844-37.582031c.976563-1.582031 1.492188-3.402344 1.492188-5.257813v-50.144531c0-3.863281-2.226563-7.382813-5.71875-9.039063zm-14.285156 56.34375-21.71875 35.167969c-7.246094 11.730469-11.074219 25.21875-11.074219 39.003907 0 10.75 2.394531 21.578124 6.933593 31.324218 9.097657 19.542969 14.5625 40.925782 16.054688 62.480469h-63.933594c-5.523437 0-10 4.476563-10 10s4.476563 10 10 10h64.371094v28.183594h-80.578125c-.042969 0-.085937 0-.128906 0h-80.574219v-36.164063c0-25.5625 5.703125-51.324218 16.488281-74.5 4.539063-9.746094 6.9375-20.578125 6.9375-31.324218 0-13.785157-3.832031-27.273438-11.074219-39.003907l-21.722656-35.167969v-40.976562l48.070313-22.765625c10.644531-5.039063 17.519531-15.90625 17.519531-27.679687v-11.300782h48.839844v11.300782c0 11.773437 6.878906 22.640624 17.519531 27.679687l48.070313 22.765625zm0 0"
      fill="url(#d)"
    />
    <path
      d="m94.339844 290.707031c-2.628906 0-5.210938 1.058594-7.070313 2.929688-1.859375 1.859375-2.929687 4.429687-2.929687 7.070312 0 2.628907 1.070312 5.210938 2.929687 7.070313 1.863281 1.859375 4.441407 2.929687 7.070313 2.929687 2.632812 0 5.210937-1.070312 7.070312-2.929687 1.871094-1.871094 2.933594-4.441406 2.933594-7.070313 0-2.640625-1.0625-5.210937-2.933594-7.070312-1.859375-1.871094-4.4375-2.929688-7.070312-2.929688zm0 0"
      fill="url(#e)"
    />
  </svg>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },

    width: {
      type: String,
      default: "512px"
    },

    height: {
      type: String,
      default: "512px"
    }
  },

  computed: {
    fillColor() {
      return this.active ? "#030C22" : "#a9a9a9";
    },
    stopColor1() {
      return this.active ? "#ff49d6" : "#a9a9a9";
    },

    stopColor2() {
      return this.active ? "#7bdfff" : "#a9a9a9";
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/showCapsule/icons/Mannequin.vue